(function(){
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.franchises = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
	        /* Custom */
	        	//Morning Edition
		         "franchise/morningedition(/e/:episode)" : "showCustom_MorningEdition"
		       	//Curate
		        ,"curate" 			 : "showCustom_Curate"
		        ,"franchise/curatetv": "showCustom_Curate"
	        /* Normal */
	        ,"franchise/:id" : "showFranchise"           /* id or slug */
        }
    })
    
    /*================================================================================
		Api - called by the Router and through Radio events
	 ================================================================================*/
    var API = {
	    showFranchise:function(id){
		    APPS.franchises.show.show(id);
	    }
	    
	    /* 
			
			Morning Edition
			
			- Has two programs, a local and a nation portion. We want to show them as a single program,
			so we're taking over the franchise page to do so.
		*/    
	    ,showCustom_MorningEdition:function(episodeSlug){
		    //get the two programs
		    $.when(  Backbone.Radio.channel('entities').request('episodes',{showId:'morningeditionlocal'}) 
		    		,Backbone.Radio.channel('entities').request('episodes',{showId:'morningeditionnational'})
		    ).done(function(dataLocal, dataNational){
	        	var ep;
	        	var date;
	        	if(!episodeSlug && !dataLocal.state.showDetails.isLive){
		        	ep = _.last(dataNational.models)
				}else if(episodeSlug){
					ep = _.find(dataNational.models,function(e){
						return e.attributes.slug === episodeSlug;
					})
				}
				
				if(ep){
					date = ep.attributes.assets[0].airdate;
					
					//We'll let the segment descriptions speak for themselves
					ep.attributes.desc_long=""; 
					ep.attributes.title="";
					
					//see if we have a local version for this date
		        	_.each(dataLocal.models,function(e){
			        	if(e.attributes.assets[0].airdate === date){
				        	ep.attributes.assets.unshift.apply(ep.attributes.assets, e.attributes.assets )
				        	//the local section is created from xml, so tell it that it's now a segment of the combined Local/Nation program
				        	ep.attributes.assets[0].type="segment";
			        	}
		        	})
	        	}
	        	
	        	dataLocal.state.showDetails.slug = "morningeditionnational";
	        	
	        	APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-radio',{
					 model : new Backbone.Model(dataLocal.state.showDetails)
					,attributes:(ep)?{ episode:ep }:""
				}));
				
				window.document.title = (ep)?ep.attributes.title:"Morning Edition";
				if(typeof ga != "undefined"){ ga('send','pageview',{ title: (ep)?ep.attributes.title:"Morning Edition" }) }
				if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': (ep)?ep.attributes.title:"Morning Edition" }); }
				if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "Morning Edition", '0', false, true); }
        	})        	
	    }
	    
	    ,showCustom_Curate:function(){
		    APPS.franchises.custom_curate.show();
	    }
    }
    
    /*================================================================================
		Radio - Event Handlers
	 ================================================================================*/
    Backbone.Radio.channel('franchise').reply("show",function(id){
        Backbone.history.navigate('/franchise/'+id)
        if(typeof ga != "undefined"){ ga('set','page','/franchise/'+id); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/franchise/'+id, 'page_location': window.location.origin+'/franchise/'+id }); }
        if(id==="curatetv"){
	        API.showCustom_Curate()
        }else{
	        API.showFranchise(id);
	    }
    })
    
    Backbone.Radio.channel('franchise').reply("show-morningedition",function(episodeSlug){
	    var url = (episodeSlug)?"/e/"+episodeSlug:"";
        Backbone.history.navigate('/franchise/morningedition'+url,{replace:true})
        if(typeof ga != "undefined"){ ga('set','page','/franchise/morningedition'+url); }
		if(typeof gtag != "undefined"){ gtag('set', { 'page_path': '/franchise/morningedition'+url, 'page_location': window.location.origin+'/franchise/morningedition'+url }); }
        API.showCustom_MorningEdition(episodeSlug);
    })
    
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();